// src/components/SearchForm.js
import React, { useState } from "react";
import { Form, Button, InputGroup, Row, Col, Modal, FormLabel } from "react-bootstrap";
import { DEFAULT_TOTAL_ANCESTORS } from "../utils/estimates";
import { signInWithGoogle, signOut as firebaseSignOut, subscribeAuth } from "../firebase";
import mixpanel from 'mixpanel-browser';
mixpanel.init("2ab96ecad7451ea49cebc5f84b528f7c");


export default function SearchForm({ onSubmit, initialQuery = "", userId }) {
  const [query, setQuery] = useState(initialQuery);
  const [totalAncestors, setTotalAncestors] = useState(DEFAULT_TOTAL_ANCESTORS);
  const [model, setModel] = useState("gpt-4o-mini");
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [specificLocation, setSpecificLocation] = useState("");
  const [ancestralInputs, setAncestralInputs] = useState("");
  const [showSignInModal, setShowSignInModal] = useState(false);


// console.log("OPENAI_KEY:", process.env.OPENAI_KEY?.slice(0, 4) + "…");

    function toggleRegion(region) {
    setSelectedRegions((prev) =>
        prev.includes(region)
        ? prev.filter((r) => r !== region)
        : [...prev, region]
    );
    }

    // function submit(e) {
    //   e.preventDefault();
    //   setShowSignInModal(true);
    // }


  function submit(e) {
    e.preventDefault();
      if (!query.trim()) {
        alert("Please enter a desired energy trait.");
        return};

      mixpanel.track('createPool', {
        signedIn: userId ? 'yes' : 'no',
        energy: query.trim(),
        ancestalLocation: ancestralInputs.trim(),
      });

      // SIgn in required
      if (!userId) {
        setShowSignInModal(true);
        return;
      }
      onSubmit({ query: query.trim(), totalAncestors: Number(totalAncestors), model, ancestralInputs });
  }

  return (
    <Form
      onSubmit={submit}
      style={{
        background: "linear-gradient(145deg, #ffffff, #f7fafc)",
        padding: "48px 36px",
        borderRadius: "28px",
        boxShadow: "0 12px 36px rgba(0,0,0,0.08)",
        border: "1px solid rgba(0,0,0,0.06)",
        transition: "0.3s",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: "26px", textAlign: "center" }}>
        <h2
          style={{
            fontWeight: 650,
            fontSize: "22px",
            lineHeight: 1.3,
            color: "#111",
            letterSpacing: "-0.5px",
          }}
        >
          {/* What if Your Ancestors Are Stars? */}
          {/* Access The Largest Pools of Positive Energies  */}
          {/* Manifest Your Desired Energies. */}
          {/* Generate Manifestation Energies */}
          {/* Supercharge Your Space */}
          Remember Your Ancestors
        </h2>
        <p
          style={{
            marginTop: "8px",
            fontSize: "15px",
            color: "#555",
            lineHeight: 1.5,
          }}
        >
          Through the Qualities They Embodied
        </p>
      </div>

      <div style={{ position: "relative" }}>
        <img
          src="/fave.png"   // <-- your location icon
          alt="favorite icon"
          style={{
            position: "absolute",
            right: "14px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "18px",
            opacity: 0.6,
            leftMargin: "8px",
          }}
        />

      {/* Trait Input */}
      <Form.Group className="mb-4">
        <Form.Control
          placeholder=" What quality? "
          // as="textarea"
          // rows={1}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{
            padding: "16px 18px",
            fontSize: "15px",
            borderRadius: "16px",
            border: "1px solid #e0e0e0",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            transition: "0.25s",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#cacacaff";
            e.target.style.boxShadow = "0 0 0 4px rgba(235, 235, 235, 0.2)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#e0e0e0";
            e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.05)";
          }}
        />
      </Form.Group>
       </div>

      {/* <div style={{ position: "relative" }}>
        <img
          src="/loca.png"   
          alt="location icon"
          style={{
            position: "absolute",
            right: "14px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "18px",
            opacity: 0.6,
            leftMargin: "8px",
          }}
        />

      <Form.Group className="mb-4" style={{ width: "100%" }}>
        <Form.Control
          placeholder="Ancestral location(s) (optional)"
          value={ancestralInputs}
          onChange={(e) => setAncestralInputs(e.target.value)}
          style={{
            padding: "14px 18px",
            fontSize: "15px",
            borderRadius: "16px",
            border: "1px solid #e0e0e0",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            transition: "0.25s",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#cacacaff";
            e.target.style.boxShadow = "0 0 0 4px rgba(235, 235, 235, 0.2)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#e0e0e0";
            e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.05)";
          }}
        />
      </Form.Group>
      </div> */}


      {/* Submit Button */}
      <Button
        type="submit"
        style={{
          width: "100%",
          padding: "16px 0",
          borderRadius: "18px",
          fontSize: "16px",
          fontWeight: 600,
          color: "#fff",
          background: "linear-gradient(120deg, #0dc300ff, #065600ff)",
          border: "none",
          boxShadow: "0 6px 18px rgba(59, 61, 60, 0.35)",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.boxShadow = "0 8px 24px rgba(46, 46, 46, 0.45)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.boxShadow = "0 6px 18px rgba(42, 45, 44, 0.35)";
        }}
      >
      <img src="/con19.png" alt="pool" style={{ width: "22px", height: "22px", marginBottom: "6px", marginRight: "6px"}} />
        Remember
      </Button>

      {/* <Modal
        show={showSignInModal}
        onHide={() => setShowSignInModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Sign in Required</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <p>Please sign in to create a pool.</p>
          <Button
            onClick={async () => {
              await signInWithGoogle();
              setShowSignInModal(false);
            }}
           style={{ 
              background: "linear-gradient(120deg, #0dc300ff, #065600ff)",
              color: "white",
              border: "none" }}
          >
            Sign in with Google
          </Button>
        </Modal.Body>
      </Modal> */}

      <Modal
        show={showSignInModal}
        onHide={() => setShowSignInModal(false)}
        centered
        backdrop="static"
      >
      <Modal.Body
        style={{
          padding: "48px 36px",
          textAlign: "center",
          borderRadius: "24px",
          background: "linear-gradient(145deg, #ffffff, #f8fafc)",
        }}
      >
        <div
          style={{
            fontSize: "42px",
            marginBottom: "18px",
          }}
        >
          ✨
        </div>

        <h3
          style={{
            fontWeight: 650,
            marginBottom: "12px",
            fontSize: "20px",
          }}
        >
          We’re Still Building This Experience
        </h3>

        <p
          style={{
            color: "#555",
            fontSize: "15px",
            lineHeight: 1.6,
            marginBottom: "28px",
          }}
        >
          This service is currently in development.
          <br />
          Please check back soon to connect with your ancestors.
        </p>

        <Button
          onClick={() => setShowSignInModal(false)}
          style={{
            padding: "12px 28px",
            borderRadius: "14px",
            fontWeight: 600,
            background: "linear-gradient(120deg, #0dc300ff, #065600ff)",
            border: "none",
            boxShadow: "0 6px 18px rgba(59, 61, 60, 0.35)",
          }}
        >
          Got it
        </Button>
      </Modal.Body>
    </Modal>

    </Form>

    
  );

}
